customElements.get("quick-add-modal") ||
  customElements.define(
    "quick-add-modal",
    class extends ModalDialog {
      constructor() {
        super(),
          (this.modalContent = this.querySelector('[id^="QuickAddInfo-"]'));
      }
      hide(e = !1) {
        $(this).hide();
        const t =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        t && t.setActiveElement(this.openedBy),
          (this.modalContent.innerHTML = ""),
          e && (this.openedBy = null),
          super.hide();
      }
      show(e) {
         $(this).show();
          
          e.setAttribute("aria-disabled", !0),
          e.classList.add("loading"),
          e
            .querySelector(".loading-overlay__spinner")
            .classList.remove("hidden");
        const t = e.getAttribute("data-product"),
          i = JSON.parse(t.replaceAll("`", '"'));
        let r = "https://anatomie.com//products/" + i.handle + ".json";
        e.getAttribute("data-product-selected-first");
        const n = i.media;
        window.bemeir_image_positions = [];
        for (let e = 0; e < n.length; e++)
          i.variants[e] &&
            i.variants[e].id &&
            window.bemeir_image_positions.push({
              id: n[e].id,
              index: e,
              variantId: i.variants[e].id,
              imagePositionVariant: i.variants[n[e].position]
                ? i.variants[n[e].position].id
                : "",
              imagePosition: n[e].position,
              src: n[e].preview_image.src,
            });
        window.addEventListener("Afterpay.ready", function () {
          Afterpay.createPlacements({
            targetSelector: "#product-price-selector",
          });
        }),
          fetch(e.getAttribute("data-product-url"))
            .then((e) => e.text())
            .then((t) => {
              const i = new DOMParser().parseFromString(t, "text/html");
              (this.productElement = i.querySelector(
                'section[id^="MainProduct-"]'
              )),
                this.preventDuplicatedIDs(),
                this.removeDOMElements(),
                this.setInnerHTML(
                  this.modalContent,
                  this.productElement.innerHTML
                ),
                window.Shopify &&
                  Shopify.PaymentButton &&
                  Shopify.PaymentButton.init(),
                window.ProductModel && window.ProductModel.loadShopifyXR(),
                this.removeGalleryListSemantic(),
                this.preventVariantURLSwitching(),
                super.show(e),
                (window.slider_product_url = r);
              yotpo.initWidgets()
            })
            .finally(() => {
              e.removeAttribute("aria-disabled"),
                e.classList.remove("loading"),
                e
                  .querySelector(".loading-overlay__spinner")
                  .classList.add("hidden"),
                window._swat
                  ? window._swat.initializeActionButtons(".splide")
                  : ((window.SwymCallbacks = window.SwymCallbacks || []),
                    window.SwymCallbacks.push(function () {
                      window._swat.initializeActionButtons(".splide");
                    }));
            });
      }
      setInnerHTML(e, t) {
        (e.innerHTML = t),
          e.querySelectorAll("script").forEach((e) => {
            const t = document.createElement("script");
            Array.from(e.attributes).forEach((e) => {
              t.setAttribute(e.name, e.value);
            }),
              t.appendChild(document.createTextNode(e.innerHTML)),
              e.parentNode.replaceChild(t, e);
          });
      }
      preventVariantURLSwitching() {
        this.modalContent
          .querySelector("variant-radios,variant-selects")
          .setAttribute("data-update-url", "false");
      }
      removeDOMElements() {
        const e = this.productElement.querySelector("pickup-availability");
        e && e.remove();
        const t = this.productElement.querySelector("product-modal");
        t && t.remove();
      }
      preventDuplicatedIDs() {
        const e = this.productElement.dataset.section;
        (this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(e, `${e}`)),
          this.productElement
            .querySelectorAll("variant-selects, variant-radios")
            .forEach((t) => {
              t.dataset.originalSection = e;
            });
      }
      removeGalleryListSemantic() {
        const e = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        e &&
          (e.setAttribute("role", "presentation"),
          e
            .querySelectorAll('[id^="Slide-"]')
            .forEach((e) => e.setAttribute("role", "presentation")));
      }
      updateImageSizes() {
        const e = this.modalContent.querySelector(".product"),
          t = e.querySelectorAll("img");
        if (!t.length) return;
        let i =
          "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";
        e.classList.contains("product--medium")
          ? (i = i.replace("715px", "605px"))
          : e.classList.contains("product--small") &&
            (i = i.replace("715px", "495px")),
          t.forEach((e) => e.setAttribute("sizes", i));
      }
    }
  );
